import GitInfo from 'react-git-info/macro';

import {config} from '../config/env';

export const getVersion = (): string | null => {
  try {
    const url = new URL(window.location.href);
    const versionParam = url.searchParams.get('version');

    if (!versionParam) {
      return null;
    }

    const isProdEnv = config.SENTRY_ENV === 'production';
    const isQAEnv = config.SENTRY_ENV === 'qa';

    const gitInfo = GitInfo();
    const tags = gitInfo?.tags || [];

    if (tags.length === 0) {
      return null;
    }

    const prefix = isProdEnv ? 'release' : isQAEnv ? 'qa' : 'dev';
    const version = tags.find((tag) => tag.startsWith(prefix)) || tags[0];

    return version || null;
  } catch (error) {
    return null;
  }
};
